/**
 * A pool gateway's letter on its colour — the same chip on the rotation
 * line, the rules' outcome line and the pool rows' order.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { cn } from '@/lib/utils';

import { gwColor, gwLetter } from '../cards/strategy-copy';

export const GatewayChip: FC<{ index: number; struck?: boolean }> = ({ index, struck }) => (
  <span
    className={cn('flex h-5 w-5 items-center justify-center rounded font-mono text-[11px] font-bold text-white', struck && 'line-through opacity-50')}
    style={{ backgroundColor: gwColor(index) }}
  >
    {gwLetter(index)}
  </span>
);
